<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <section :class="b()">
    <div :class="b('score-head')">
      <h3 :class="b('title')">{{ title }}</h3>
      <slot name="header-extra" />
    </div>

    <div :class="b('score-main')">
      <slot name="amount" />

      <SharedCryptoSelect
        :placeholder="$t('Выберите счет')"
        :options="options"
        :value="value"
        @update:value="$emit('update:value', $event)"
        @create="$emit('create')"
      />
    </div>

    <slot name="footer" />
  </section>
</template>
